var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.6 653.5c37.1 58.4 34.2 76.3 1.9 108.6-41.2 41.2-46.4 73.4-1.9 143.4 4.2 6.5 12.8 8.4 19.3 4.3 6.5-4.2 8.4-12.8 4.3-19.3-37.1-58.4-34.2-76.3-1.9-108.6 41.2-41.2 46.4-73.4 1.9-143.4-4.2-6.5-12.8-8.4-19.3-4.3-6.5 4.1-8.5 12.8-4.3 19.3zM276.6 653.5c37.1 58.4 34.2 76.3 1.9 108.6-41.2 41.2-46.4 73.4-1.9 143.4 4.2 6.5 12.8 8.4 19.3 4.3 6.5-4.2 8.4-12.8 4.3-19.3-37.1-58.4-34.2-76.3-1.9-108.6 41.2-41.2 46.4-73.4 1.9-143.4-4.2-6.5-12.8-8.4-19.3-4.3-6.5 4.1-8.4 12.8-4.3 19.3zM726.5 762.1c-41.2 41.2-46.4 73.4-1.9 143.4 4.2 6.5 12.8 8.4 19.3 4.3 6.5-4.2 8.4-12.8 4.3-19.3-37.1-58.4-34.2-76.3-1.9-108.6 41.2-41.2 46.4-73.4 1.9-143.4-4.2-6.5-12.8-8.4-19.3-4.3-6.5 4.2-8.4 12.8-4.3 19.3 37.1 58.4 34.2 76.3 1.9 108.6zM64.4 226.1v223.8c0 61.9 50.1 112.1 112 112.1h672c61.8 0 112-50.2 112-112.1V226.1c0-61.9-50.1-112.1-112-112.1h-672c-61.8 0-112 50.2-112 112.1z",
    fill: "#3c7fb9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4 226.1c0-30.9 25.1-56.1 56-56.1h672c30.9 0 56 25.1 56 56.1v223.8c0 30.9-25.1 56.1-56 56.1h-672c-30.9 0-56-25.1-56-56.1V226.1z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.4 268c0-23.1 18.4-42 41.7-42h84.5c23.2 0 41.7 19.1 41.7 42 0 23.1-18.4 42-41.7 42h-84.5c-23.1 0-41.7-19.1-41.7-42zM232.4 268c0-23.2 19-42 42-42 23.2 0 42 19 42 42 0 23.2-19 42-42 42-23.2 0-42-19-42-42zM246.4 394h532v-28h-532v28zM246.4 450h532v-28h-532v28z",
    fill: "#3c7fb9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4 268c0 7.5 6.1 14 13.7 14h84.5c7.7 0 13.7-6.3 13.7-14 0-7.5-6.1-14-13.7-14h-84.5c-7.7 0-13.7 6.3-13.7 14zM260.4 268c0 7.5 6.3 14 14 14 7.5 0 14-6.3 14-14 0-7.5-6.3-14-14-14-7.5 0-14 6.3-14 14z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir);
export default __webpack_public_path__ + "static/media/air.b696da81af78bbc5b8659db3a5fe2de6.svg";
export { ForwardRef as ReactComponent };